import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

type ChartRow = {
  name: string;
  posts: number;  // 게시글
  comments: number; // 댓글
};

const LABEL_MAP: Record<string, string> = {
  posts: "게시글",
  comments: "댓글",
};

type DashBoardBarChart2Props = {
  data?: ChartRow[];
  height?: number;
  showLegend?: boolean;
};

const DashBoardBarChart2: React.FC<DashBoardBarChart2Props> = ({
  data = [],
  height = 320,
  showLegend = true,
}) => {
  return (
    <div style={{ width: "100%", height }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 20, right: 0, left: 0, bottom: 5 }}>
          <CartesianGrid vertical={false} stroke="#F2F4F7" strokeDasharray="0" />
          <XAxis
            dataKey="name"
            tick={{ fill: "#344054", fontSize: 14 }}
            axisLine={{ stroke: "#F2F4F7" }}
            tickLine={false}
          />
          <YAxis
            width={32}
            tick={{ fill: "#344054", fontSize: 14 }}
            axisLine={false}
            tickLine={false}
          />

          <Tooltip
            contentStyle={{
              backgroundColor: "#fff",
              border: "1px solid #D9D9D9",
              borderRadius: 8,
              padding: "8px 10px",
              color: "#4B566C",
              boxShadow: "0 8px 24px rgba(16, 24, 40, 0.14)",
            }}
            labelStyle={{ color: "#4B566C", fontSize: 16 }}
            itemStyle={{ color: "#4B566C", fontSize: 16, fontWeight: 600 }}
            formatter={(value, name) => [value, LABEL_MAP[name as string] ?? name]}
          />

          {showLegend && (
            <Legend iconType="circle" wrapperStyle={{ fontSize: 15 }}
            formatter={(value) => <span style={{ color: "#333" }}>{value}</span>} />
          )}
          <Bar dataKey="posts" stackId="a" name="게시글" fill="#31d19f" barSize={16} />
          <Bar dataKey="comments" stackId="a" name="댓글" fill="#F97575" barSize={16} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default DashBoardBarChart2;
